import React, { useEffect } from 'react';

import Icons from 'assets/images/Icons';
import classNames from 'classnames';
import SelectInput from 'components/SelectInput';

interface DataTablePaginationProps {
  page: number
  totalItems: number
  setPage(page: number): void
}

const DataTablePagination = ({ page, totalItems, setPage }: DataTablePaginationProps) => {
  const totalPages = Math.max(Math.ceil(totalItems / 10), 1);

  // If the list shrinks below the current page (e.g. after a delete), clamp back
  // to the last page instead of showing an empty "page N of M<N".
  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);
  const changePage = (pageNumber: string) => {
    setPage(parseInt(pageNumber));
  };
  const pageUp = () => {
    if(totalPages > page) {
      setPage(page + 1);
    }
  };
  const pageDown = () => {
    if(1 < page) {
      setPage(page - 1);
    }
  };

  const pluralize = (word: string, itemsCount: number) => 1 === itemsCount ? word : `${word}s`;


  return (
    <div className='helpers end'>
      <span>
        {totalItems === 0 ? 0 : page * 10 - 9} - {page * 10 < totalItems
          ? page * 10
          : totalItems } of {totalItems} {pluralize('item', totalItems)}
      </span>
      <SelectInput
        value={page}
        className='pane-switcher'
        options={Array(totalPages).fill(true).map((_, k) => ({
          name: `${k + 1}`,
          value: k + 1,
        }))}
        onChange={changePage}
      />

      {/* <select className='pane-switcher' value={ page } onChange={ changePage }>
        {Array( totalPages ).fill( true ).map( ( _, k ) => (
          <option value={ k + 1 } key={ k + 1 }>{k + 1}</option>
        ) )}
      </select> */}
      <span>of {totalPages} {pluralize('page', totalPages)}</span>
      <button className={classNames({
        disabled: 1 === page,
        'neu-inset': true,
      })} onClick={pageDown}><Icons name='Arrow' className='left' /></button>
      <button className={classNames({
        disabled: page === totalPages,
        'neu-inset': true,
      })} onClick={pageUp}><Icons name='Arrow' /></button>
    </div>
  );
};

export default DataTablePagination;